import React, {useEffect, useState, useRef, useCallback} from 'react';
import {AdvancedMarker, Pin, useMap } from '@vis.gl/react-google-maps';
import {MarkerClusterer} from '@googlemaps/markerclusterer';
import CustomeInfoWindow from './CustomeInfoWindow'

const CustomeAdvancedMarker = ({ points, closeInfo, openPoint: openLeasePoint, 
    openMarketPoint, isClustered, handleInfoClose, setOpenWindowSelectedCoordenate,
    setOpenWindowSelectedMarketCoordenate, routeCalculation }) => {
    const map = useMap();
    const [markers, setMarkers] = useState({});
    const [selectedMarker, setSelectedMarker] = useState([])
    const clusterer = useRef(null);
    const [infoWindowOpen, setInfoWindowOpen] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState("Copy Coordinate")

    const showInfoWindow = (openPoint, fromClickEvent) => {
        setCopyButtonText("Copy Coordinate")

        let newSelectedMarket
        if(openPoint.lease) {
          newSelectedMarket = [openPoint.key, selectedMarker[1] || openMarketPoint?.key]
        } else {
          newSelectedMarket = [selectedMarker[0] || openLeasePoint?.key, openPoint.key]
        } 
        
        setSelectedMarker([...newSelectedMarket])

        if(fromClickEvent && openPoint.lease) {
          setOpenWindowSelectedCoordenate(openPoint)
        }

        if(fromClickEvent && openPoint.station) {
          setOpenWindowSelectedMarketCoordenate(openPoint)
        }

        setInfoWindowOpen(true);
    };

    const showRouteCalcInfoWindow = (openLeasePoint, openMarketPoint) => { 
      setCopyButtonText("Copy Coordinate")

      let newSelectedMarket = [openLeasePoint.key, openMarketPoint.key]
      setSelectedMarker([...newSelectedMarket])

      setInfoWindowOpen(true);
    };

    const hideInfoWindow = (openPoint) => {
      let newSelectedMarket
      if(openPoint.lease) {
        setOpenWindowSelectedCoordenate(null)
        newSelectedMarket = [undefined, selectedMarker[1]]
      } else {
        setOpenWindowSelectedMarketCoordenate(null)
        newSelectedMarket = [selectedMarker[0], undefined]
      } 
      
      setSelectedMarker(newSelectedMarket)
    };

    useEffect(() => {
      if (!map) return;
      if(!isClustered) return;
      if (!clusterer.current) {
        clusterer.current = new MarkerClusterer({map});
      }
    }, [map]);
  
    useEffect(() => {
      clusterer.current?.clearMarkers();
      clusterer.current?.addMarkers(Object.values(markers));
    }, [markers]);

    useEffect(() => {
      return () => {
          clusterer.current?.clearMarkers();
      }
    }, []);

    useEffect(() => {
      clusterer.current?.clearMarkers();
    }, [points]);

    useEffect(() => {
      if(openLeasePoint) {
        showInfoWindow(openLeasePoint)
      }
    }, [openLeasePoint]);

    useEffect(() => {
      if(openMarketPoint) {
        showInfoWindow(openMarketPoint)
      }
    }, [openMarketPoint]);

    useEffect(() => {
      if(routeCalculation) {
        if(openMarketPoint && openLeasePoint) {
          showRouteCalcInfoWindow && showRouteCalcInfoWindow(openLeasePoint, openMarketPoint)
        }
      }
    }, [routeCalculation]);

    useEffect(() => {
      if(closeInfo && setOpenWindowSelectedCoordenate) {
        setSelectedMarker([])
        setOpenWindowSelectedCoordenate && setOpenWindowSelectedCoordenate(null)
        setOpenWindowSelectedMarketCoordenate && setOpenWindowSelectedMarketCoordenate(null)
        handleInfoClose()
      }
    }, [closeInfo]);
  

    const setMarkerRef = useCallback((marker, key) => {
      setMarkers(prev => {
        if (marker) {
          if (prev[key]) return prev;
          return {...prev, [key]: marker};
        } else {
          if (!prev[key]) return prev;
          const newMarkers = {...prev};
          delete newMarkers[key];
          return newMarkers;
        }
      });
    }, []);

    const copyToClipboard = (point) => {
      navigator.clipboard.writeText(`${point.lat}, ${point.lng}`)
      setCopyButtonText("Copied!")
    }
  
    return (
        <>
          {points.map(point => (
            <React.Fragment key={point.key}>
                <AdvancedMarker 
                    position={point}
                    clickable={true}
                    onClick={() => showInfoWindow(point, true)}
                    ref={marker => setMarkerRef(marker, point.key)}
                    >
                        <Pin
                            background={point.color}
                            borderColor={'#000000'}
                            glyphColor={'#FFFFFF'}
                        />
                </AdvancedMarker>
                
                {infoWindowOpen && selectedMarker.includes(point.key) && (
                    <CustomeInfoWindow point={point} hideInfoWindow={() => hideInfoWindow(point)} copyButtonText={copyButtonText} copyToClipboard={copyToClipboard} />
                )}
            </React.Fragment>
          ))}
        </>
      );
  };

export default CustomeAdvancedMarker